<section
    class="agpr-monitoringKeywordGroup"
    *ngIf="value"
>
    <div
        class="agpr-monitoringKeywordGroup-container"
    >
        <div
            class="agpr-monitoringKeywordGroup-top"
            [ngClass]="{'agpr-monitoringKeywordGroup-top--collapsed': !containerExpanded}"
        >
            <div class="agpr-monitoringKeywordGroup-top-left">
                <div
                    *ngIf="index !== 0"
                    class="agpr-monitoringKeywordGroup-logicOperator"
                >
                    {{ 'and' | localize }}
                </div>
                <div class="agpr-monitoringKeywordGroup-top-left-heading">
                    <h4 [ngClass]="{'agpr-monitoringKeywordGroup-top-left-heading-spaced': !showDelete}">{{ 'Monitoring.keyWordGroup.keywordGroupName' | localize: { id: index + 1 } }}</h4>
                    <agpr-button
                        *ngIf="showDelete"
                        [id]="id + '_deleteKeywordGroup_' + index"
                        class="agpr-monitoringKeywordGroup-delete"
                        [ngClass]="{'agpr-monitoringKeywordGroup-delete--visible': showDelete}"
                        [tooltip]="showDelete ? 'Monitoring.keyWordGroup.deleteKeywordGroup' : ''"
                        [style]="buttonTypes.icon"
                        icon="fa-regular fa-duotone fa-trash-can"
                        (click)="clickDelete()"
                    ></agpr-button>
                </div>
                <div
                    class="agpr-monitoringKeywordGroup-top-left-searchContext"
                    [@containerState]="containerExpanded ? 'visible' : 'hidden'"
                >
                    <agpr-monitoring-search-contexts
                        [(ngModel)]="value.searchContexts"
                        (ngModelChange)="processSearchContextsChange($event)"
                    ></agpr-monitoring-search-contexts>
                </div>
                <span *ngIf="!containerExpanded" class="agpr-monitoringKeywordGroup-top-left-searchContext-summary">
                    {{'Monitoring.search.search' | localize}} {{'Monitoring.keyWordGroup.summary.' + searchContext | localize }}
                    <span *ngIf="searchContext === searchContexts.text">
                        <br>
                        <span>
                            <ng-container *ngFor="let context of value.searchContexts; let last = last">
                                {{context.name | localize }}<span *ngIf="!last">,</span>
                            </ng-container>
                        </span>
                    </span>

                </span>
            </div>
            <div class="agpr-monitoringKeywordGroup-divider"></div>
            <div class="agpr-monitoringKeywordGroup-top-keywords">
                <agpr-button
                    [id]="id + '_expandToggle_' + index"
                    class="agpr-monitoringKeywordGroup-expand agpr-expandToggle"
                    [ngClass]="{'agpr-monitoringKeywordGroup-expand--disabled': disableExpandToggles}"
                    [style]="buttonTypes.icon"
                    [icon]="containerExpanded ? 'fa-solid fa-angle-up' : 'fa-solid fa-angle-down'"
                    (click)="containerExpanded = !containerExpanded;"
                    [disabled]="disableExpandToggles"
                    [tooltip]="containerExpanded ? (disableExpandToggles ? 'Monitoring.keyWords.expandToggle.disabled' : 'Core.collapse') : 'Core.expand'"
                ></agpr-button>
                <div
                    class="agpr-monitoringKeywordGroup-top-keywords-container"
                    [@containerState]="containerExpanded ? 'visible' : 'hidden'"
                >
                    <agpr-monitoring-keywords
                        [id]="id + '_keywords'"
                        [ngModel]="value"
                        (ngModelChange)="writeValue(value)"
                        [isImageSearch]="searchContext === searchContexts.images"
                    ></agpr-monitoring-keywords>
                </div>
                <div
                    *ngIf="!containerExpanded"
                    class="agpr-monitoringKeywordGroup-summary"
                >
                    <div *ngIf="value.and.length" class="agpr-monitoringKeywordGroup-summary-group">
                        <ng-container *ngTemplateOutlet="summaryChips; context: {$implicit: value.and, lastIndex: lastVisibleChipAnd, operator: operatorEnum.and}">
                        </ng-container>
                    </div>
                    <div *ngIf="value.or.length" class="agpr-monitoringKeywordGroup-summary-group">
                        <ng-container *ngTemplateOutlet="summaryChips; context: {$implicit: value.or, lastIndex: lastVisibleChipOr, operator: operatorEnum.or}">
                        </ng-container>
                    </div>
                    <div *ngIf="value.not.length" class="agpr-monitoringKeywordGroup-summary-group">
                        <ng-container *ngTemplateOutlet="summaryChips; context: {$implicit: value.not, lastIndex: lastVisibleChipNot, operator: operatorEnum.not}">
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="containerExpanded" class="agpr-monitoringKeywordGroup-findRelatedConcepts">
            <agpr-related-concepts
                [index]="index"
                [keywordGroup]="keywords"
                (updateKeywords)="addConceptKeywords($event)"
            ></agpr-related-concepts>
        </div>
    </div>
</section>

<ng-template #summaryChips let-chips let-lastIndex="lastIndex" let-operator="operator">
    <label class="agpr-monitoringKeywordGroup-summary-label">{{operator | localize}}</label>
    <ul
        class="agpr-monitoringKeywordGroup-summary-chips"
        agprElementOverflowParent
        [elements]="chips"
        (lastVisibleElementIndex)="areChipsOverflowingChange($event, operator)"
    >
        <li
            *ngFor="let chip of chips; let i = index;"
            class="agpr-chip"
        >
            <span
                class="agpr-chip-label"
                [pTooltip]="chip"
                tooltipPosition="top"
            >
                {{chip}}
            </span>
            <agpr-button
                [id]="id + '_' + operator + '_chip-' + i + '_delete'"
                class="agpr-chip-button"
                [style]="buttonTypes.icon"
                icon="fa-regular fa-duotone fa-xmark"
                tooltip="delete"
                tooltipPosition="top"
                (click)="removeKeywordChip(operator, i)"
            ></agpr-button>
            <span *ngIf="i === lastIndex" class="agpr-monitoringKeywordGroup-summary-ellipsis">...</span>
        </li>
    </ul>
</ng-template>


